import { findMany, find, on } from '../Libraries/helpers'

const turnOn = button => {
    const text = find('.button-text', button)
    const spinner = find('.button-spinner', button)

    button.classList.add('cursor-wait')
    text.classList.add('opacity-50')
    spinner.classList.remove('hidden')

    setTimeout(() => button.disabled = true, 0)
}

const turnOff = button => {
    const text = find('.button-text', button)
    const spinner = find('.button-spinner', button)

    button.classList.remove('cursor-wait')
    text.classList.remove('opacity-50')
    spinner.classList.add('hidden')

    setTimeout(() => button.disabled = false, 0)
}

findMany('[data-spinner]').forEach(button => {
    const isHash = (button.getAttribute('href') || '').indexOf('#') === 0;
    const timeout = isHash ? 300 : 3500;

    on('click', () => {
        button.classList.contains('cursor-wait') ? turnOff(button) : turnOn(button);
        setTimeout(() => turnOff(button), timeout)
    }, button)
})
